import { Button } from "@mui/material"
import { TStepsKeys } from "../../Models/common"

type TStepnavigationProps = { capturedSteps: TStepsKeys[], nextButtonLable?: string, prevSection?: TStepsKeys, currentSection:TStepsKeys, goToNextSection?: () => any, goToPrevSection?: () => any }

const StepNavigation = ({ capturedSteps, goToNextSection, goToPrevSection, nextButtonLable, prevSection, currentSection }: TStepnavigationProps) => (
    capturedSteps.includes(prevSection!) || capturedSteps.includes(currentSection) ?
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
            {capturedSteps.includes(currentSection) ? <Button variant='contained' type='submit' onClick={goToNextSection}>{nextButtonLable}</Button> : <></>}
            {capturedSteps.includes(prevSection!) ? <Button variant='outlined' type='submit' color='secondary' onClick={goToPrevSection}>{'Back'}</Button> : <></>}
        </div> :
        <></>
)

export default StepNavigation